<template>
    <div class="d_radio">
        <input
            type="radio"
            :id="id"
            :name="name"
            :value="value"
            v-model="localValue"
        />
        <label :for="id">{{ label }}</label>
    </div>
</template>

<script>
export default {
    name: 'RadioBox',
    props: {
        modelValue: {
            type: [String, Number],
            required: true
        },
        value: {
            type: [String, Number],
            required: true
        },
        label: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        id: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            localValue: this.modelValue,
        };
    },
    watch: {
        localValue(newVal) {
            this.$emit('update:modelValue', newVal);
        },
        modelValue(newVal) {
            this.localValue = newVal;
        },
    },
};
</script>
